import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import RbUploadingModalComponent from '../components/rb-uploading-modal/rb-uploading-modal.jsx';

import {
    closeUploading
} from '../reducers/modals';

// import {
//     closeHelpMenu
// } from '../reducers/menus';

class RbUploadingModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel'
        ]);
        this.state = {
            percent: 0
        };
    }

    componentDidMount () {
        this.timerID = setInterval(() => {
            if (this.state.percent <= 90) {
                this.setState({
                    percent: this.state.percent + (Math.floor((Math.random() * 3) + 1))
                });
            } else if (this.state.percent >= 99) {
                clearInterval(this.timerID);
            } else {
                this.setState({
                    percent: this.state.percent + 1
                });
            }
        }, 300);
    }

    componentWillUnmount () {
        clearInterval(this.timerID);
    }

    handleCancel (e) {
        e.stopPropagation();
        this.props.onClose();
    }

    render () {
        return (
            <RbUploadingModalComponent
                percent={this.state.percent}
                uploadModalType={this.props.uploadModalType}
                onCancel={this.handleCancel}
            />
        );
    }
}

RbUploadingModal.propTypes = {
    onClose: PropTypes.func,
    uploadModalType: PropTypes.string
};

const mapStateToProps = state => ({
    uploadModalType: state.scratchGui.modals.uploadModalType
});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeUploading());
        // dispatch(closeHelpMenu());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RbUploadingModal);
